import PropTypes from "prop-types";
import { useState } from "react";


const UserContrasena = ({ user,  updateUser, loadUsers }) => {

  const [isEditing, setIsEditing] = useState(false);
  const [isPasswordDisabled, setIsPasswordDisabled] = useState(true);
  const [formData, setFormData] = useState({
    id_usuario: String(user.id_usuario || ""), 
    usuario: user.usuario || "",
    contrasena: ""
  });  

  const [errors, setErrors] = useState({});  
  
  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    })); 

    const newErrors = { ...errors };

    if (name === "contrasena") {
      if (!value || value.trim() === "") {
        // Verifica si el campo está vacío o solo tiene espacios en blanco
        delete newErrors.contrasena;
      } else if (/\s/.test(value)) {
        // Verifica si contiene espacios en blanco
        newErrors.contrasena = "La contrasena no puede contener espacios.";
      } else if (value.length < 8) {
        // Verifica la longitud mínima
        newErrors.contrasena = "La contrasena debe tener al menos 8 caracteres.";
      } else if (!/[A-Z]/.test(value)) {
        // Verifica la existencia de al menos una letra mayúscula
        newErrors.contrasena = "Debe incluir al menos una letra mayúscula.";
      } else if (!/[0-9]/.test(value)) {
        // Verifica la existencia de al menos un número
        newErrors.contrasena = "Debe incluir al menos un número.";
      } else {
        // Si todas las validaciones pasan, se elimina cualquier error
        delete newErrors.contrasena;
      }
    }   
    setErrors(newErrors);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    const dataToSend = { ...formData };
    if (formData.contrasena === "") {
      delete dataToSend.contrasena;
    }
    try {
      dataToSend.estatura=parseFloat(dataToSend.estatura)

      await updateUser(formData.id_usuario, dataToSend);
      alert("Usuario actualizado con éxito.");
      await loadUsers();
    } catch (error) {
      console.error("Error actualizando usuario:", error);
    }    
  };
  const isFormInvalid = () => {
    // Verificar si hay errores en el objeto errors
    const hasErrors = Object.values(errors).some((error) => error !== "");

    // Verificar que los campos obligatorios estén llenos
    const requiredFieldsFilled = 
      user.nombre_completo !== "";

    return hasErrors || !requiredFieldsFilled;
  };

  const handleEditClick = () => {
    setIsEditing(!isEditing);
    setIsPasswordDisabled(!isPasswordDisabled);
  };

  return (
    <form onSubmit={handleSubmit}>
      <br></br>
      CURP: {user.curp}
      <p></p>
      {Object.keys(formData).map((key) => {
        if (key === "id_usuario" || key === "usuario") {
          return null; // Do not render these hidden fields
        }
        let inputElement;

        if (key === "contrasena") {

          inputElement = (
            <input
              type="text"
              name={key}
              value={formData[key]}
              onChange={handleChange}
              disabled={!isEditing || (key === "contrasena" && isPasswordDisabled)} 
              /*required={key === "correo_electronico"} */
              className="input"
            />
          );
        }

        return (
          <div key={key} className="input-group">
            <label className="label">{key.replace(/_/g, " ")}</label>{errors[key] && <span className="error">{errors[key]}</span>}
            {inputElement}
          </div>
        );
      })}
      <p></p>
      <button type="button" onClick={handleEditClick} className="button">
        {isEditing ? "Proteger Campos" : "Modificar información"}
      </button>
      <p></p>
      <button type="submit" disabled={!isEditing} className={`${isFormInvalid() ? 'button-disabled' : 'button'}`}>
        Actualizar (Aplicar cambios)
      </button>
      <p></p>
    </form>    
  );
  
};

UserContrasena.propTypes = {
  user: PropTypes.object.isRequired,
  updateUser: PropTypes.func.isRequired,
  getUsers: PropTypes.func,
  loadUsers: PropTypes.func,
};



export default UserContrasena;

